// Vigencia corta de una fila de lista: cuenta regresiva al inicio o al fin, en una línea.
import { daysBetweenDays, formatDateMx, formatDayMx, mxDay } from '@/lib/dateHelpers';

function isCalendarDay(value: string): boolean {
    return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

/** El día de calendario de una fecha (día suelto o instante ISO) en el piso de venta. */
export function lifecycleDay(value: string): string {
    return isCalendarDay(value) ? value : mxDay(value);
}

/** `DD/MMM/YYYY` de un día suelto o de un instante, sin correr el día suelto de zona. */
export function formatLifecycleDate(value: string): string {
    return isCalendarDay(value) ? formatDayMx(value) : formatDateMx(value);
}

/**
 * «Arranca hoy/mañana/en N días», «Vence en N días», «Último día», «Venció el …» o «Permanente».
 * Con `now`, un inicio de hoy que todavía no llega dice «Arranca hoy».
 */
export function describeValidityCountdown(
    validFrom: string | null,
    validUntil: string | null,
    today: string,
    now?: Date,
): string {
    if (validFrom !== null) {
        const start = daysBetweenDays(lifecycleDay(validFrom), today);
        if (start === 1) return 'Arranca mañana';
        if (start > 1) return `Arranca en ${String(start)} días`;
        if (start === 0 && startsLaterToday(validFrom, now)) return 'Arranca hoy';
    }
    if (validUntil === null) return 'Permanente';
    const remaining = daysBetweenDays(lifecycleDay(validUntil), today);
    if (remaining < 0) return `Venció el ${formatLifecycleDate(validUntil)}`;
    if (remaining === 0) return 'Último día';
    return remaining === 1 ? 'Vence mañana' : `Vence en ${String(remaining)} días`;
}

/** Un instante de inicio que todavía no llega; un día suelto arranca a medianoche. */
function startsLaterToday(validFrom: string, now: Date | undefined): boolean {
    if (now === undefined || isCalendarDay(validFrom)) return false;
    return Date.parse(validFrom) > now.getTime();
}
